<template>
  <transition name="o-the-modal-transition-fade">
    <div
      v-show="$modal.isModalVisible"
      class="o-the-modal"
    >
      <MoleculeTheModalContent>
        <MoleculeTheModalContentSlot
          :is="modalBody"
          slot="modal-body"
        />
      </MoleculeTheModalContent>
      <MoleculeTheModalShadow/>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'OrganismTheModal',

  components: {
    MoleculeTheModalContent: () => import('@/components/molecules/MoleculeTheModalContent'),
    MoleculeTheModalShadow: () => import('@/components/molecules/MoleculeTheModalShadow')
  },

  computed: {
    modalBody () {
      if (this.$modal.isModalVisible && this.$modal.modalBody !== null) {
        return () => import(`@/components/molecules/${this.$modal.modalBody}`)
      } else {
        return null
      }
    }
  }
}
</script>
